<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-培训行业-修改
    -->
    <el-dialog
    title="修改培训行业"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">修改培训行业</div>

      <el-form-item label="培训行业名称" prop="name"><el-input v-model="form.name" placeholder="请输入培训行业名称" class="max-w460"></el-input></el-form-item>
      
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</el-dialog>
  
</template>

<script>
import Ma_training_industryApi from '@/api/ma_training_industry.js';

export default {
  data() {
    return {
      form: {
        name: '',
        code: 'custom'
      },
      loading: false,
      rules: {
        name: [{ required: true, message: '请输入培训行业名称', trigger: 'blur' }],
      },
      dialogVisible: false
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","ma_training_industry_id"],
  methods: {
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      Ma_training_industryApi.detail({ma_training_industry_id: self.ma_training_industry_id},true).then(res => {
          self.form.name = res.data.name;
          self.loading = false;
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      form.ma_training_industry_id = self.ma_training_industry_id;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Ma_training_industryApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_training_industry/index/part/edit.vue